import { render, staticRenderFns } from "./shopLink.vue?vue&type=template&id=0f5c5a76"
import script from "./shopLink.vue?vue&type=script&lang=js"
export * from "./shopLink.vue?vue&type=script&lang=js"
import style0 from "./shopLink.vue?vue&type=style&index=0&id=0f5c5a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports